module.exports = __webpack_public_path__ + "static/img/30-2.f2b4fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/30-2.jpg
// module id = pomV
// module chunks = 0